module.exports = __webpack_public_path__ + "static/media/web.f8eb571c.jpg";